export enum ProductCategoryType {
  Fibre = 1,
  Wireless = 2,
  Voice = 3,
  Hardware = 4,
  ValueAddedService = 5,
  AdditionalHandset = 6,
  LTETopup = 7,
}